export interface IChanges<T> {
  detected: boolean;
  properties: string[];
  changes: Partial<T>;
}

export class ChangesService {

  public static getValueOrDefault = (v: any, def: any): any => {
    if (v) return v;
    if (typeof (v) === 'undefined') return def;
    if (v === null) return def;
    if (v === '') return def;
    return v;
  }

  private static addChange<T>(result: IChanges<T>, propName: keyof T, newValue: any) {
    result.detected = true;
    result.properties.push(propName as string);
    result.changes[propName] = newValue;
  }

  public static getChanges<T>(item: Partial<T>, request: Partial<T>, props?: (keyof T)[]): IChanges<T> {
    const result: IChanges<T> = {
      detected: false,
      changes: {},
      properties: []
    };

    if (!props)
      props = Object.keys(request) as (keyof T)[];

    props.forEach(propName => {
      let oldValue = this.getValueOrDefault(item[propName], null);
      let newValue = this.getValueOrDefault(request[propName], null);

      if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        ChangesService.addChange(result, propName, newValue);
      }
    });
    return result;
  }

}
